import { render, staticRenderFns } from "./PushClient.vue?vue&type=template&id=12c9b236&"
import script from "./PushClient.vue?vue&type=script&lang=js&"
export * from "./PushClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports